export default __webpack_public_path__ + "static/media/Step2.92ca7904.jpg";